import { useLayoutEffect, useState } from 'react';

export function useElementWidth(ref: React.RefObject<HTMLElement>) {
  const [width, setWidth] = useState(ref.current?.offsetWidth ?? 0);

  useLayoutEffect(() => {
    const listener = () => {
      setWidth(ref.current?.offsetWidth ?? 0);
    };
    window.addEventListener('resize', listener);
    listener();
    return () => {
      window.removeEventListener('resize', listener);
    };
  });

  return width;
}
